module.exports = __webpack_public_path__ + "img/01.a61b1654.jpg";